<template>
  <div class="flex flex-col items-center justify-center h-full space-y-2.5 my-auto px-3 !pt-0">
    <div
      class="flex flex-col p-6 w-full md:w-3/4 lg:w-1/2 mx-auto border shadow-xl rounded-lg 2xl:w-1/3 bg-white"
    >
      <div class="flex items-center space-x-10 justify-center">
        <img
          src="/images/logo-clear.png"
          class="w-32"
        >

        <div>
          <h1 class="text-2xl font-semibold break-words w-min my-auto">
            Construction Commercial Management
          </h1>

          <p class="font-bold text-ccm-blue-500">
            <span class="font-bold text-[#bb6101]">Get Control</span>

            <br class="sm:hidden">

            <span class="font-bold text-ccm-blue-500">
              Keep Control
            </span>
          </p>
        </div>
      </div>

      <form
        v-if="!success"
        class="flex flex-col space-y-6 w-4/5 mx-auto mt-6"
        action="/forgot-password"
        @submit.prevent="resetPassword"
      >
        <h2 class="text-2xl md:text-3xl font-semibold break-words text-center text-gray-800">
          {{ $t('ResetPassword.title') }}
        </h2>

        <label>
          {{ $t('ResetPassword.label.email') }}
          <AppInput
            v-model="passwordForm.form.email"
            type="email"
            name="email"
            :error="passwordForm.getErrors('email')"
            required
            class="form-input"
            autofocus
          />
        </label>

        <div
          class="flex w-full space-x-2"
        >
          <button
            type="submit"
            class="w-full btn btn--primary-blue"
          >
            {{ $t('ResetPassword.sendPasswordResetLink') }}
          </button>
        </div>
      </form>

      <div
        v-else
        class="text-center"
      >
        <h2 class="text-2xl md:text-3xl font-semibold break-words text-center mt-4 text-gray-800">
          {{ $t('ResetPassword.passwordResetLinkSent') }}
        </h2>

        <p class="mt-2">
          {{ $t('ResetPassword.passwordResetLinkSentMessage') }}
        </p>
      </div>

      <RouterLink
        :to="{ name: 'Login' }"
        class="btn btn--tertiary-blue ml-auto mt-10"
      >
        {{ $t('ResetPassword.logIn') }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFormData } from '@/composables/useFormData';
import AxiosClient from '@/services/AxiosClient';
import Swal from 'sweetalert2';
import { ref } from 'vue';

const passwordForm = useFormData({
  email: '',
});

const success = ref(false);

const resetPassword = () => {
  AxiosClient.bootstrap();

  AxiosClient.postRequest('/forgot-password', passwordForm.form).then(([_data, error]) => {
    success.value = true;

    if(error && error.status !== 422) {
      Swal.fire({
        icon: 'error',
        title: 'Error resetting password.',
        text: 'Please try clearing your cookies before trying again.',
      });
    }
  });
};
</script>

<style scoped></style>
